import type {ReactNode} from 'react';
import {MobileTopBar} from 'components/MobileTopBar';
import {useHomeData} from '../useHomeData';

export function MobileShell({children}: {children: ReactNode}) {
  const {propertyName} = useHomeData();

  return (
    <div className="flex h-[var(--app-dvh,100dvh)] flex-col bg-[var(--background-main)] lg:block lg:h-auto lg:bg-transparent">
      <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden lg:flex-none lg:overflow-visible">
        <MobileTopBar propertyName={propertyName} className="sticky top-0 z-20" />
        {children}
      </div>
    </div>
  );
}
